<template>
    <div v-if="isShow" :style="domStyle">
        <div :style="headerStyle">
            <div class="headerbox" @click="BackOff">
                <Icon type="ios-arrow-back" color="#fff" size="20"/>
            </div>
            <div class="headerbox" :style="middleHeaderStyle">
                {{titleName}}
            </div>
        </div>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
export default {
    name : "",
    props : ["primitives","fvSystemApi","parentObject"],
    created(){
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.parentObject.width + "px",
            backgroundColor : "#1D3352"    
        }
        this.headerStyle ={
            width  : "100%",
            height : "100%",
            display: "flex",
            alignItems : "center",
            //justifyContent: "space-between"
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        }
        this.titleListName = [this.titleName];//列表头部名称
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
        if(this.OnClick && this.OnClick != "%OnClick%"){
            this.OnClick = AsyncFunction(this.OnClick);
        }
        Object.defineProperty(this,"Title",{
            set(value){
                //用于监听 修改title 维护一个数组
                if(value != this.titleListName[this.titleListName.length-1]){
                    this.titleListName.push(value)
                }
                this.titleName = value;
                this.$forceUpdate();
            },
            get(){
                return this.titleName;
            }
        })
    },
    data(){
        return {
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            headerStyle:{},
            // 版本号
            version: "10.0.3.1"
        }
    },
    computed: {
        sideHeaderStyle(){
            return {
                width : 10 + "%",
                textAlign:"center"
            }
        },
        middleHeaderStyle(){
            return {
                width : "100%",
                height: "100%",
                overflow:"hidden",
                textOverflow:"ellipsis",
                whiterSpace:"nowrap",
                textAlign : 'center',
                color : "#fff",
                fontSize : '20' + "px",
                float: "left"
            }
        }
    },
    methods : {
        /*
            参数：src 原json数据
            作用：混淆数据到当前对象
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){},
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.isEnable) return;
        },
        /*
            参数：无
            作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
        */
        onClose(){
            return new Promise((resolve)=>{
                resolve();
            })
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            if(this.fontSize){
                this.$el.style.fontSize = parseInt(parseInt(this.fontSize.substr(0, this.fontSize.length - 2)) * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px"; 
            }
            // this.$el.style.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            // this.$el.style.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
            this.$el.style.width = 100 + "%";
            // this.$el.style.height = 100 + "%";
            // this.$el.style.lineHeight = this.$el.clientHeight + "px";
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        /*
            参数：无，
            作用：设置返回窗口
        */
        BackOff(){
            /**返回需要打开其他窗口关闭勾选， 主页不用勾选 */
            var list = this.fvSystemApi.system.manager.$.openList;
            if(list.length>3){
                if(list.length == 4){
                    for(var k in this.$store.state.system.manager){
                        if(k == '$') continue;
                        if(this.$store.state.system.manager[k].$.height>80){
                            if(list[list.length-1] != k){
                                var name = k ;
                            }
                        }
                    }
                    if(list[list.length-2] == name) {
                        this.fvSystemApi.system.manager.$.openView(list[list.length-2],"header");
                        //关闭当前打开的 pc窗口多个会出现问题
                        this.fvSystemApi.system.manager.$.closeWindow(list[list.length-1])
                        this.fvSystemApi.system.manager.$.openList.pop();
                    }else{
                        this.fvSystemApi.system.manager.$.openView(name,"header");
                        //关闭当前打开的 pc窗口多个会出现问题
                        this.fvSystemApi.system.manager.$.closeWindow(list[list.length-1])
                        this.fvSystemApi.system.manager.$.openList.pop();
                    }
                }else{
                    this.fvSystemApi.system.manager.$.openView(list[list.length-2],"header");
                    //关闭当前打开的 pc窗口多个会出现问题
                    this.fvSystemApi.system.manager.$.closeWindow(list[list.length-1])
                    this.fvSystemApi.system.manager.$.openList.pop();
                }
                
                
            }
            if(this.titleListName.length>1){
                //用维护的列表来返回对应的名称
                this.titleName = this.titleListName[this.titleListName.length-2];
                this.$forceUpdate();
                this.titleListName.pop();
            }
            // if(typeof this.OnClick == "function"){
            //    this.fvSystemApi.executionScript(this.OnClick,"");
            // }
        }
    }
}
</script>

<style>
    .headerbox{
        display: inline-block;
    }

</style>


// WEBPACK FOOTER //
// src/components/primitives/fvAppHeader/fvAppHeader.vue